<template>
  <div class="">
    
    <div class="row mt-4">
      <!--section client-->

      <div class="col-md-6 col-lg-6 col-sm-12">
        <v-container v-if="progress" type="image" class="loding">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-container>
        <form v-else @submit.prevent="addCLI">
          <div class="background-white mt-3">
            <div class="title">
              <div class="position">{{ $t("CLIENT") }}</div>
            </div>
          </div>
          <div class="center borderPointier mt-3 p-3">
            <ClientStep
            @error-response="handleErrorResponse" 
              :clientParentData="clientData"
              :idLogementData="logementData.id"
              :showAddClientButton="true"
              @add-client="openClientModal"
              @update-client="handleClientUpdate"
              :logementValue="logementData"
              :menageValue="menageData"
              ref="creeClient"
            />
          </div>
        </form>
      </div>
      <div class="col-md-6 col-lg-6 col-sm-12">
        <form>
          <div>
            <v-container v-if="progress" type="image" class="loding">
              <v-skeleton-loader type="image"></v-skeleton-loader>
            </v-container>
            <!--section logement-->
            <div v-else class="borderPointier mt-3 pt-4 px-3">
              <div class="background-white mb-2" style="top: -1.5rem;">
                <div class="title">
                  <div class="align-items-center">
                    <div class="position ">{{ $t("HOUSING") }}</div>
                  </div>
                </div>
              </div>

              <LogementStep
                :logementParentData="logementData"
                :clientId="clientLogementsOptions"
                :clientType="clientData?.type"
                :sameTravaux="sameTravaux"
                :showAddLogementButton="true"
                @add-logement="openLogementModal"
                @update-logement="handleLogementUpdate"
                @update-same-travaux-address="handleSameTravaux"
              />
            </div>

            <div v-if="isParticulier">
              <v-container v-if="progress" type="image" class="loding">
                <v-skeleton-loader type="image"></v-skeleton-loader>
              </v-container>
              <!--section logement-->
              <div v-else class="borderPointier mt-3 pt-3 px-3">
                <div class="background-white">
                  <div class="title">
                    <div class="position">{{ $t("Informations fiscal") }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 pl-2 mt-3 py-0">
                    <b-form-group :label="$t('Foyer fiscaux')">
                      <b-form-input
                        v-model="menageData.foyer_fiscal"
                        @input="handleMenageUpdate({ field: 'foyer_fiscal', value: $event })"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 py-0">
                    <b-form-group :label="$t('Année des revenus')">
                      <b-form-input
                        v-model="menageData.annee_revenus"
                        type="number"
                        min="1900"
                        max="2100"
                        @input="handleMenageUpdate({ field: 'annee_revenus', value: $event })"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 pl-2 py-0">
                    <b-form-group :label="$t('Année d’imposition')">
                      <b-form-input
                        v-model="menageData.annee_imposition"
                        type="number"
                        min="1900"
                        max="2100"
                        @input="handleMenageUpdate({ field: 'annee_imposition', value: $event })"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <MenagesStep
                  :menageParentData="menageData"
                  @update-menage="handleMenageUpdate"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-4">
      <b-button @click="goToPrevStep" class="button-pre-style m-3">
        {{ $t("PREVIOUS") }}
      </b-button>

      <b-button
        type="submit"
        @click="goToNextStep"
        class="button-suivant-style m-3"
      >
        {{ $t("NEXT") }}
        <div class="loading ml-2" v-if="isLoading">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
        <div class="loading ml-2" v-if="isLoadingButton">
          <div class="spinner-border spinner-border-sm" role="status"></div>
        </div>
      </b-button>
    </div>
    <!-- Modals création client / logement + refresh listes -->
    <clientmodale @updateList="loadClients" />
    <logementmodale 
      ref="logementModal"
      :clientContext="logementClientContext"
      @updateList="handleLogementCreated" 
    />
    <Snackbar ref="snackbar" class="mt-5" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Snackbar from "@/components/ui/errorSnackbar.vue";
import ClientStep from "../client/ClientStep.vue";
import LogementStep from "../logement/LogementStep.vue";
import MenagesStep from "../menages/MenagesStep.vue";
import clientmodale from "@/components/Ajoutmodel/clientmodale.vue";
import logementmodale from "@/components/Ajoutmodel/logementmodale.vue";
export default {
  components: {
    ClientStep,
    Snackbar,
    LogementStep,
    MenagesStep,
    clientmodale,
    logementmodale,
  },
  props: {
    isLoadingButton: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emittedResponse: null,
      cl:null,
      page: 1,
      logementData: null,
      menageData: null,
      clientData: null,
      clientAdd: false,
      logementAdd: false,
      sameTravaux: null,
      isLoading: false,
      clientLogementsOptions: [],
      optionsprecarite: [
        { value: "Modeste", text: this.$t("Modeste") },
        { value: "Intermédiaires", text: this.$t("Intermédiaires") },
        { value: "tres_modeste", text: this.$t("Tmodeste") },
        { value: "supérieurs", text: this.$t("Supérieurs") },
      ],
    };
  },
  created() {
    this.logementData = this.initializeLogementData();
    this.clientData = this.initializeClientData();
    console.log(' this.clientData',  this.clientData)
    this.menageData = this.initializeMenageData();
    this.sameTravaux = this.initializeSameTravaux();

    this.clientAdd = this.getdevisMonoFiche.data.devis.client === null;
    this.logementAdd = this.getdevisMonoFiche.data.devis.logement === null;

    // Charger la liste des clients (pour le multiselect dans ClientStep)
    this.loadClients();
    // Charger les logements du client courant
    this.loadClientLogements();
    
    // Afficher le statut du devis dans la console
    const devisStatus = this.getdevisMonoFiche?.data?.devis?.status || null;
    console.log('=== STATUT DU DEVIS DANS STEP CLIENT ===', devisStatus);
    console.log('=== DEVIS COMPLET ===', this.getdevisMonoFiche?.data?.devis);
    
    // Formater les numéros de téléphone après l'initialisation
    this.$nextTick(() => {
      this.formatPhoneNumbers();
    });
  },
  activated() {
    // Réinitialiser les données depuis getdevisMonoFiche quand on revient à l'étape
    // Cela garantit que les modifications sauvegardées sont prises en compte
    this.clientData = this.initializeClientData();
    this.logementData = this.initializeLogementData();
    this.menageData = this.initializeMenageData();
    this.sameTravaux = this.initializeSameTravaux();
    
    // Afficher le statut du devis dans la console
    const devisStatus = this.getdevisMonoFiche?.data?.devis?.status || null;
    console.log('=== STATUT DU DEVIS DANS STEP CLIENT (ACTIVATED) ===', devisStatus);
    console.log('=== DEVIS COMPLET (ACTIVATED) ===', this.getdevisMonoFiche?.data?.devis);
    
    // Formater les numéros de téléphone après la réinitialisation
    this.$nextTick(() => {
      this.formatPhoneNumbers();
    });
    // Recharger les logements du client courant
    this.loadClientLogements();
  },
  computed: {
    ...mapGetters(["getdevisMonoFiche", "getOnlineUser"]),
    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    isParticulier() {
      return this.clientData && this.clientData.type === 'type.particulier';
    },
    logementClientContext() {
      // Contexte client/entreprise depuis le devis pour le modal de logement
      const clientId = this.getdevisMonoFiche?.data?.devis?.client_id || this.clientData?.id;
      const entrepriseId = this.getdevisMonoFiche?.data?.devis?.entreprise?.id || this.clientData?.entreprise?.id;
      
      if (!clientId || !entrepriseId) {
        return null;
      }
      
      return {
        id: clientId,
        entreprise_id: entrepriseId,
        entreprise: {
          id: entrepriseId
        }
      };
    },
  },
  watch: {
    clientData: {
      handler(newValue) {
        if (newValue.menage) {
          this.menageData = {
            commune: newValue.menage.commune || null,
            personnes: newValue.menage.personnes || null,
            revenu: newValue.menage.revenu || null,
            foyer_fiscal: newValue.menage.foyer_fiscal || null,
            annee_revenus: newValue.menage.annee_revenus || null,
            annee_imposition: newValue.menage.annee_imposition || null,
          };
        } else {
          this.menageData = {
            commune: null,
            personnes: null,
            revenu: null,
            foyer_fiscal: null,
            annee_revenus: null,
            annee_imposition: null,
          };
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapActions([
      "editLogement",
      "editMenage",
      "edit_client",
      "storeMenage",
      "storeLogement",
      "all_clients",
      "pays",
      "store_clients",
      "client",
      "store_client",
      "all_countries",

      "setDevisMonoFiche",
      "clientLogements",
    ]),

    openClientModal() {
      this.$root.$emit("bv::show::modal", "clientStoreModal");
    },
    openLogementModal() {
      // Ouvrir le modal via ref pour s'assurer que le contexte est bien passé
      if (this.$refs.logementModal) {
        this.$refs.logementModal.$refs.logementStoreModal.show();
      } else {
        this.$root.$emit("bv::show::modal", "logementStoreModal");
      }
    },
    async loadClients() {
      const entrepriseId = this.getdevisMonoFiche?.data?.devis?.entreprise?.id;
      if (!entrepriseId) return;

      await this.all_clients({
        search: "",
        page: this.page,
        per_page: 100000,
        entreprise_id: entrepriseId,
      });
    },
    async loadClientLogements() {
      const clientId =
        this.getdevisMonoFiche?.data?.devis?.client_id || this.clientData?.id;
      if (!clientId) {
        this.clientLogementsOptions = [];
        return;
      }
      const res = await this.clientLogements(clientId);
      if (Array.isArray(res)) {
        this.clientLogementsOptions = res;
      } else if (Array.isArray(res?.data)) {
        this.clientLogementsOptions = res.data;
      } else {
        this.clientLogementsOptions = [];
      }

      // À l'initialisation : déterminer l'id du logement à partir du devis
      const devis = this.getdevisMonoFiche?.data?.devis;
      const logementId =
        devis?.logement_id ?? devis?.logement?.id ?? this.logementData?.id;

      // Debug pour vérifier les valeurs utilisées
      console.log(
        "DEBUG loadClientLogements -> logementId (devis.logement_id / devis.logement.id / logementData.id) =",
        logementId
      );
      console.log(
        "DEBUG loadClientLogements -> clientLogementsOptions ids =",
        this.clientLogementsOptions.map((l) => l.id)
      );

      if (
        this.clientLogementsOptions.length > 0 &&
        logementId != null &&
        logementId !== ""
      ) {
        const foundLogement = this.clientLogementsOptions.find(
          (l) => Number(l.id) === Number(logementId)
        );
        console.log(
          "DEBUG loadClientLogements -> foundLogement =",
          foundLogement
        );
        console.log(
          "DEBUG loadClientLogements -> foundLogement.id =",
          foundLogement?.id
        );
        if (foundLogement) {
          // Logement trouvé : on initialise le step avec ce logement complet
          // Utiliser foundLogement comme base et compléter avec les valeurs par défaut si nécessaire
          const initialData = this.initializeLogementData();
          // Construire l'objet final en préservant toutes les propriétés nécessaires
          const updatedLogementData = {
            ...initialData,
            ...foundLogement,
            // FORCER l'id à être celui du logement trouvé (source de vérité)
            id: foundLogement.id,
          };
          // Utiliser Vue.set pour garantir la réactivité
          Object.keys(updatedLogementData).forEach((key) => {
            this.$set(this.logementData, key, updatedLogementData[key]);
          });
          // S'assurer que l'id est bien défini avec Vue.set
          this.$set(this.logementData, "id", foundLogement.id);
          console.log(
            "DEBUG loadClientLogements -> logementData après mise à jour =",
            this.logementData
          );
          console.log(
            "DEBUG loadClientLogements -> logementData.id après mise à jour =",
            this.logementData.id
          );
          console.log(
            "DEBUG loadClientLogements -> foundLogement.id =",
            foundLogement.id
          );
        } else {
          // Logement non trouvé dans la liste : on laisse la sélection vide
          this.logementData = { ...this.initializeLogementData(), id: null };
        }
      }
    },
    handleLogementCreated(res) {
      const createdId = res?.data?.id;

      // Recharger le client courant pour mettre à jour ses logements
      const clientId = this.getdevisMonoFiche?.data?.devis?.client_id;
      if (clientId) {
        this.client(clientId).then((clientRes) => {
          if (clientRes && clientRes.data) {
            this.clientData.logements = clientRes.data.logements || [];
            this.getdevisMonoFiche.data.devis.client.logements =
              this.clientData.logements;
            this.setDevisMonoFiche(this.getdevisMonoFiche);
          }
        });
      }

      // Recharger la liste depuis /clients/{id}/logements, puis sélectionner le logement créé
      this.loadClientLogements().then(() => {
        if (createdId) {
          const found = this.clientLogementsOptions.find(
            (l) => l.id === createdId
          );
          if (found) {
            // Mettre à jour immédiatement le logement sélectionné dans le step
            this.logementData = { ...this.logementData, ...found };
          }
        }
      });
    },
  
    handleErrorResponse(response) {
      this.emittedResponse = response; // Stocke la valeur dans une propriété locale
      console.log("Réponse reçue :", response); // Affiche dans la console pour vérifier
    },
    initializeLogementData() {
      const devis = this.getdevisMonoFiche?.data?.devis;
      const logement = devis?.logement || {};
      // Priorité à devis.logement_id pour l'id (source de vérité à l'initialisation)
      const id = devis?.logement_id ?? logement?.id ?? null;
      console.log(
        "DEBUG initializeLogementData -> devis.logement_id =",
        devis?.logement_id
      );
      console.log("DEBUG initializeLogementData -> logement.id =", logement?.id);
      console.log("DEBUG initializeLogementData -> id final =", id);
      return {
        id,
        type_energie_equipement_deposee:
          logement?.type_energie_equipement_deposee || null,
        equipement_deposee: logement?.equipement_deposee || null,
        residence_principale_proprietaire:
          logement?.residence_principale_proprietaire || false,
        proprietaire_occupant: logement?.proprietaire_occupant || false,
        type_chauffage: logement?.type_chauffage || null,
        type: logement?.type || null,
        periode_de_construction: logement?.periode_de_construction || "",
        surface: logement?.surface || "",
        parcelle_cadastrale: logement?.parcelle_cadastrale || "",
        adresse: logement?.adresse || "",
        altitude: logement?.altitude || null,
        NPDL: logement?.NPDL || null,
        NPRM: logement?.NPRM || null,
        NPCE: logement?.NPCE || null,
        secteur_activite: logement?.secteur_activite || null,
        siret: logement?.siret || null,
        nom_site: logement?.nom_site || null,
        complement: logement?.complement || null,
        code_postal: logement?.code_postal || null,
        complement_adresse: logement?.complement_adresse || null,
        ville: logement?.ville || null,
        quartier_qpv: logement?.quartier_qpv || null,
        nom_de_quartier: logement?.nom_de_quartier || null,
        code_de_quartier: logement?.code_de_quartier || null,
        surface_au_sol: logement?.surface_au_sol || null,
        
      };
    },
    initializeClientData() {
      console.log('this.getdevisMonoFiche?.data?.devis.client', this.getdevisMonoFiche?.data?.devis.client)
      const client = this.getdevisMonoFiche?.data?.devis.client || {};
      
      // Initialiser l'email : priorité à company_email, sinon email
      let emailValue = client?.company_email || client?.email || null;
      
      return {
        nom: client?.nom || "",
        prenom: client?.prenom || "",
        rue: client?.rue || "",
        zone: client?.zone || null,
        cp: client?.cp || "",
        ville: client?.ville || "",
        id: client.id || null,
        precarite: client?.precarite || null,
        type: client?.type || "type.particulier",
        email: emailValue,
        pays: client?.pays || null,
        phone: client?.phone || null,
        company_phone: client?.company_phone,
        company_phone_iso_code: client?.company_tel?.phone_iso_code || null,
        tel: {
          phone_number: client.phone?.phone_number || null,
          phone_iso_code: client.phone?.iso_code || null,
        },
        company_tel: {
          phone_number: client.company_phone?.phone_number || null,
          phone_iso_code: client.company_phone?.iso_code || null,
        },
        company: client.company || null,
        company_email: client.company_email || client.email || null,
        revenu_avis_imposition: client.revenu_avis_imposition || 0,
        SWIFT_BIC: client.SWIFT_BIC || null,
        forme_juridique: client.forme_juridique || null,
        ape: client.ape || null,
        naf: client.naf || null,
        IBAN: client.IBAN || null,
        titulaire_compte: client.titulaire_compte || null,
        poste: client.poste || "",
        commentaire: client.commentaire || null,
        logements: client.logements || [],
        menage: client.menage || [],
        // Champs pour les clients particuliers
        civilite_1: client?.civilite_1 || null,
        civilite_2: client?.civilite_2 || null,
        nom_2: client?.nom_2 || null,
        prenom_2: client?.prenom_2 || null,
        email_2: client?.email_2 || null,
        complement_adresse: client?.complement_adresse || null,
        tel_mobile: client?.tel_mobile || (client?.phone ? {
          phone_number: client.phone.phone_number || null,
          phone_iso_code: client.phone.iso_code || null,
        } : null),
        tel_fixe: (() => {
          // Si tel_fixe existe et est un objet
          if (client?.tel_fixe && typeof client.tel_fixe === 'object') {
            return {
              phone_number: client.tel_fixe.phone_number || null,
              phone_iso_code: client.tel_fixe.phone_iso_code || client.tel_fixe.iso_code || 'FR',
              formated_phone: client.tel_fixe.formated_phone || null,
            };
          }
          // Si tel_fixe_phone_number existe
          if (client?.tel_fixe_phone_number) {
            return {
              phone_number: client.tel_fixe_phone_number,
              phone_iso_code: client.tel_fixe_phone_iso_code || 'FR',
              formated_phone: null,
            };
          }
          // Si tel_fixe est une chaîne
          if (client?.tel_fixe && typeof client.tel_fixe === 'string') {
            return {
              phone_number: client.tel_fixe,
              phone_iso_code: client.tel_fixe_phone_iso_code || 'FR',
              formated_phone: null,
            };
          }
          return null;
        })(),
        // Champs pour les clients professionnels
        raison_sociale: client?.raison_sociale ?? "",
        nom_commercial: client?.nom_commercial ?? "",
        siret: client?.siret ?? "",
        civilite: client?.civilite ?? null,
        signataire_nom: client?.signataire_nom ?? null,
        signataire_prenom: client?.signataire_prenom || null,
        fonction: client?.fonction || null,
        type_occupation: client?.type_occupation || null,
       
        tel_mobile_pro: client?.tel_mobile_pro || (client?.phone ? {
          phone_number: client.phone.phone_number || null,
          phone_iso_code: client.phone.iso_code || null,
          formated_phone: client.phone.formated_phone || null,
        } : null),
        tel_fixe_pro: client?.tel_fixe_pro || (client?.company_phone ? {
          phone_number: client.company_phone.phone_number || null,
          phone_iso_code: client.company_phone.iso_code || null,
          formated_phone: client.company_phone.formated_phone || null,
        } : null),
      };
    },

    initializeMenageData() {
      const menage = this.getdevisMonoFiche?.data?.devis?.client?.menage || {};
      return {
        
        revenu: menage.revenu || null,
        personnes: menage.personnes || null,
        commune: menage.commune || "",
        foyer_fiscal: menage.foyer_fiscal || null,
        annee_revenus: menage.annee_revenus || null,
        annee_imposition: menage.annee_imposition || null,
      };
    },
    initializeSameTravaux() {
      // Initialiser same_travaux_address depuis le devis
      return this.getdevisMonoFiche?.data?.devis?.same_travaux_address || null;
    },
    updateMenageData() {
      if (this.clientData?.menage) {
        this.menage = {
          revenu: this.clientData.menage.revenu || null,
          personnes: this.clientData.menage.personnes || null,
          commune: this.clientData.menage.commune || "",
        };
      }
    },
    async edit() {
      if (this.clientAdd) {
      await this.$refs.creeClient.addCLI();
      
        // await this.addCLI();
        await this.all_clients({
          search: "",
          page: this.page,
          per_page: 100000,
          entreprise_id: this.getdevisMonoFiche.data.devis.entreprise.id,
        });
        // Utiliser clientData.id en priorité, sinon utiliser client_id du devis
        const clientIdToUse = this.clientData?.id || this.getdevisMonoFiche.data.devis.client_id;
        
        if (!clientIdToUse) {
          this.$refs.snackbar.showSnackbar( `${this.$t("Tous_obligatoires")}`);
          this.isLoading = false;
          return;
        }
        
        // S'assurer que client_id est à jour dans le devis
        if (this.clientData?.id && this.getdevisMonoFiche.data.devis.client_id !== this.clientData.id) {
          this.getdevisMonoFiche.data.devis.client_id = this.clientData.id;
        }
        
        const client = await this.client(clientIdToUse);

        const log = {
          ...this.logementData,
          client_id: client?.data.id,
        };
        
        // Si l'ID du logement est null, créer un nouveau logement
        let logementresult;
        const logementIdToUse = this.logementData.id || this.getdevisMonoFiche.data.devis.logement_id;
        console.log('DEBUG LOGEMENT (clientAdd): logementIdToUse =', logementIdToUse);
        console.log('DEBUG LOGEMENT (clientAdd): this.logementData.id =', this.logementData.id);
        console.log('DEBUG LOGEMENT (clientAdd): devis.logement_id =', this.getdevisMonoFiche.data.devis.logement_id);
        
        if (!logementIdToUse) {
          // Créer un nouveau logement
          console.log('DEBUG LOGEMENT (clientAdd): Appel storeLogement');
          logementresult = await this.storeLogement(log);
          this.getdevisMonoFiche.data.devis.logement_id = logementresult.data.id;
          this.logementData.id = logementresult.data.id;
        } else {
          // Mettre à jour le logement existant
          console.log('DEBUG LOGEMENT (clientAdd): Appel editLogement avec ID:', logementIdToUse);
          log.id = logementIdToUse;
          const editResult = await this.editLogement(log);
          console.log('DEBUG LOGEMENT (clientAdd): editResult =', editResult);
          
          // Vérifier si l'update a échoué
          if (typeof editResult === 'string' && editResult.toLowerCase().includes('error')) {
            console.error('Erreur lors de la mise à jour du logement:', editResult);
            this.$refs.snackbar.showSnackbar(`${this.$t("Erreur lors de la mise à jour du logement")}`);
            this.isLoading = false;
            return;
          }
          if (!editResult || !editResult.id) {
            console.error('Erreur lors de la mise à jour du logement:', editResult);
            this.$refs.snackbar.showSnackbar(`${this.$t("Erreur lors de la mise à jour du logement")}`);
            this.isLoading = false;
            return;
          }
          
          logementresult = { data: { id: editResult.id } };
          // S'assurer que logement_id est à jour dans le devis
          if (this.getdevisMonoFiche.data.devis.logement_id !== editResult.id) {
            this.getdevisMonoFiche.data.devis.logement_id = editResult.id;
          }
        }
        
        this.getdevisMonoFiche.data.devis.logement = {
          id: logementresult.data.id,
          adresse: this.logementData.adresse,
          type: this.logementData.type,
          proprietaire_occupant: this.logementData.proprietaire_occupant,
          residence_principale_proprietaire:
            this.logementData.residence_principale_proprietaire,
          equipement_deposee: this.logementData.equipement_deposee,
          type_energie_equipement_deposee:
            this.logementData.type_energie_equipement_deposee,
          periode_de_construction: this.logementData.periode_de_construction,
          surface: this.logementData.surface,
          parcelle_cadastrale: this.logementData.parcelle_cadastrale,
          type_chauffage: this.logementData.type_chauffage,
          altitude: this.logementData.altitude,
          NPDL: this.logementData.NPDL,
          NPRM: this.logementData.NPRM,
          NPCE: this.logementData.NPCE,
          secteur_activite: this.logementData.secteur_activite,
          siret: this.logementData.siret,
          nom_site: this.logementData.nom_site,
          complement: this.logementData.complement,
          code_postal: this.logementData.code_postal,
          complement_adresse: this.logementData.complement_adresse,
          ville: this.logementData.ville,
          quartier_qpv: this.logementData.quartier_qpv,
          nom_de_quartier: this.logementData.nom_de_quartier,
          code_de_quartier: this.logementData.code_de_quartier,
          surface_au_sol: this.logementData.surface_au_sol,
        };
        
        // S'assurer que logement_id est bien défini dans le devis
        this.getdevisMonoFiche.data.devis.logement_id = logementresult.data.id;
        
        // Sauvegarder immédiatement les modifications du logement
        this.setDevisMonoFiche(this.getdevisMonoFiche);
        
        const clientObject = {
          id: this.getdevisMonoFiche.data.devis.client_id,
          precarite: this.clientData?.precarite ?? client.data.precarite,
          pays: this.clientData?.pays ?? client.data.pays,
          nom: this.clientData?.nom ?? client.data.nom,
          prenom: this.clientData?.prenom ?? client.data.prenom,
          rue: this.clientData?.rue ?? client.data.rue,
          zone: this.clientData?.zone ?? client.data.zone,
          type: this.clientData?.type ?? client.data.type,
          ville: this.clientData?.ville ?? client.data.ville,
          tel: this.clientData?.tel ?? client.data.tel,
          phone: client.data.phone, // Garder phone depuis l'API car c'est un objet complexe
          company_phone: client.data.company_phone, // Garder company_phone depuis l'API
          cp: this.clientData?.cp ?? client.data.cp,
          email: this.clientData?.email ?? client.data.email,
          company: this.clientData?.company ?? client.data.company,
          company_email: this.clientData?.company_email ?? client.data.company_email,
          SWIFT_BIC: this.clientData?.SWIFT_BIC ?? client.data.SWIFT_BIC,
          forme_juridique: this.clientData?.forme_juridique ?? client.data.forme_juridique,
          naf: this.clientData?.naf ?? client.data.naf,
          ape: this.clientData?.ape ?? client.data.ape,
          revenu_avis_imposition: this.clientData?.revenu_avis_imposition ?? client.data.revenu_avis_imposition,
          IBAN: this.clientData?.IBAN ?? client.data.IBAN,
          titulaire_compte: this.clientData?.titulaire_compte ?? client.data.titulaire_compte,
          poste: this.clientData?.poste ?? client.data.poste,
          commentaire: this.clientData?.commentaire ?? client.data.commentaire,
          company_tel: client.data.company_tel, // Garder company_tel depuis l'API
          logements: this.clientData?.logements ?? client.data.logements,
          // Champs pour les clients particuliers
          civilite_1: this.clientData?.civilite_1 ?? client.data.civilite_1,
          civilite_2: this.clientData?.civilite_2 ?? client.data.civilite_2,
          nom_2: this.clientData?.nom_2 ?? client.data.nom_2,
          prenom_2: this.clientData?.prenom_2 ?? client.data.prenom_2,
          email_2: this.clientData?.email_2 ?? client.data.email_2,
          complement_adresse: this.clientData?.complement_adresse ?? client.data.complement_adresse,
          tel_mobile: this.clientData?.tel_mobile ?? client.data.tel_mobile,
          tel_fixe: this.clientData?.tel_fixe ?? client.data.tel_fixe,
          // Champs pour les clients professionnels
          raison_sociale: this.clientData?.raison_sociale ?? client.data.raison_sociale,
          nom_commercial: this.clientData?.nom_commercial ?? client.data.nom_commercial,
          siret: this.clientData?.siret ?? client.data.siret,
          civilite: this.clientData?.civilite ?? client.data.civilite,
          signataire_nom: this.clientData?.signataire_nom ?? client.data.signataire_nom,
          signataire_prenom: this.clientData?.signataire_prenom ?? client.data.signataire_prenom,
          fonction: this.clientData?.fonction ?? client.data.fonction,
          type_occupation: this.clientData?.type_occupation ?? client.data.type_occupation,
         
          tel_mobile_pro: this.clientData?.tel_mobile_pro ?? client.data.tel_mobile_pro,
          tel_fixe_pro: this.clientData?.tel_fixe_pro ?? client.data.tel_fixe_pro,
        };
        
        // Pour les clients professionnels, s'assurer que email et company_email sont bien mappés depuis email
        if (this.clientData.type === "type.professionnel") {
          // Mapper email vers email et company_email pour professionnel
          if (this.clientData.email) {
            clientObject.email = this.clientData.email;
            clientObject.company_email = this.clientData.email;
          } else if (this.clientData.company_email) {
            clientObject.email = this.clientData.company_email;
            clientObject.company_email = this.clientData.company_email;
          }
          
          // S'assurer que siret est inclus même si null
          if (this.clientData.siret !== undefined) {
            clientObject.siret = this.clientData.siret;
          }
        }
        
        // Ajouter le ménage uniquement s'il existe (pour les clients particuliers)
        const menageToUse = this.clientData?.menage && Object.keys(this.clientData.menage).length > 0 
          ? this.clientData.menage 
          : (client.data.menage || null);
          
        if (menageToUse && (this.clientData?.type === 'type.particulier' || client.data.type === 'type.particulier')) {
          clientObject.menage = {
            id: menageToUse.id || (menageToUse.data?.id),
            revenu: this.menageData?.revenu ?? menageToUse.revenu ?? menageToUse.data?.revenu,
            personnes: this.menageData?.personnes ?? menageToUse.personnes ?? menageToUse.data?.personnes,
            commune: this.menageData?.commune ?? menageToUse.commune ?? menageToUse.data?.commune,
            foyer_fiscal: this.menageData?.foyer_fiscal ?? menageToUse.foyer_fiscal ?? menageToUse.data?.foyer_fiscal ?? null,
            annee_revenus: this.menageData?.annee_revenus ?? menageToUse.annee_revenus ?? menageToUse.data?.annee_revenus ?? null,
            annee_imposition: this.menageData?.annee_imposition ?? menageToUse.annee_imposition ?? menageToUse.data?.annee_imposition ?? null,
          };
        }
        
        this.getdevisMonoFiche.data.devis.client = clientObject;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      } else {
        // Cas: clientAdd est false (client existant)
        if (this.clientData.id === null) {
          this.$refs.snackbar.showSnackbar(
             `${this.$t("Vérifiez vos données ou sélectionnez un client existant")}`
          );
          this.isLoading = false;
          return;
        }
        
        // Mettre à jour le client si nécessaire
        if (
          this.getdevisMonoFiche.data.devis?.client &&
          this.getdevisMonoFiche.data.devis?.client?.id !== this.clientData.id
        ) {
          // Le client a changé - faire une mise à jour complète
          if (!this.clientData) {
            return;
          }
          this.getdevisMonoFiche.data.devis.client_id = this.clientData.id;
          this.getdevisMonoFiche.data.devis.same_travaux_address = 0;
          const client = {
            ...this.clientData,
            id: this.clientData.id,
            revenu_avis_imposition: this.clientData.revenu_avis_imposition,
            phone_iso_code: this.clientData.tel.iso_code,
            company_phone_iso_code:
              this.clientData?.company_tel?.phone_iso_code,
          };
          if (this.clientData.type === "type.particulier") {
            client.phone_number = this.clientData.tel.phone_number;
          } else {
            const phone = this.cleanPhoneNumber(
              this.clientData.tel.phone_number
            );
            client.phone_number = this.removeSpaces(phone);

            const company_phone = this.cleanPhoneNumber(
              this.clientData?.company_tel?.phone_number
            );
            client.company_phone_number = this.removeSpaces(company_phone);
          }
          client.revenu_avis_imposition =
            this.clientData.revenu_avis_imposition;
          
          // Pour les clients professionnels, s'assurer que siret et email sont bien inclus
          if (this.clientData.type === "type.professionnel") {
            // S'assurer que siret est inclus
            if (this.clientData.siret !== undefined && this.clientData.siret !== null) {
              client.siret = this.clientData.siret;
            }
            
            // Mapper email vers email et company_email pour professionnel
            if (this.clientData.email) {
              client.email = this.clientData.email;
              client.company_email = this.clientData.email;
            } else if (this.clientData.company_email) {
              client.email = this.clientData.company_email;
              client.company_email = this.clientData.company_email;
            } else if (this.clientData.email) {
              client.email = this.clientData.email;
              client.company_email = this.clientData.email;
            }
            
            // Mapper nom et prenom depuis signataire pour professionnel
            if (this.clientData.signataire_nom) {
              client.nom = this.clientData.signataire_nom;
            }
            if (this.clientData.signataire_prenom) {
              client.prenom = this.clientData.signataire_prenom;
            }
            
            // Mapper poste depuis fonction pour professionnel
            if (this.clientData.fonction) {
              client.poste = this.clientData.fonction;
            }
          }
          
          const editClientResult = await this.edit_client({ data: client });
          
          // Vérifier si l'update du client a échoué
          if (!editClientResult || (typeof editClientResult === 'string' && editClientResult.toLowerCase().includes('error'))) {
            console.error('Erreur lors de la mise à jour du client:', editClientResult);
            this.$refs.snackbar.showSnackbar(`${this.$t("Erreur lors de la mise à jour du client")}`);
            this.isLoading = false;
            return;
          }
        } else {
          // Le client n'a pas changé - faire une mise à jour légère si nécessaire
          const client = {
            ...this.clientData,
            id: this.getdevisMonoFiche.data.devis.client.id,
            revenu_avis_imposition: this.clientData.revenu_avis_imposition,
            phone_iso_code: this.clientData.tel.iso_code,
            company_phone_iso_code:
              this.clientData?.company_tel?.phone_iso_code,
          };
          
          // Supprimer les objets de téléphone avant l'envoi
          delete client.tel_mobile;
          delete client.tel_fixe;
          delete client.tel_mobile_pro;
          delete client.tel_fixe_pro;
          delete client.tel;
          delete client.company_tel;
          delete client.phone;
          delete client.company_phone;
          
          if (this.clientData.type === "type.particulier") {
            const phone = this.cleanPhoneNumber(
              this.clientData.tel.phone_number
            );
            client.phone_number = this.removeSpaces(phone);
            
            // Formater tel_fixe comme string
            if (this.clientData.tel_fixe && this.clientData.tel_fixe.phone_number) {
              let telFixeNumber = this.clientData.tel_fixe.phone_number;
              
              // Retirer le préfixe du pays et les espaces
              // Si le numéro contient un espace, prendre la partie après le premier espace
              const spaceIndex = telFixeNumber.indexOf(" ");
              if (spaceIndex !== -1) {
                telFixeNumber = telFixeNumber.slice(spaceIndex + 1).split(" ").join("");
              } else {
                // Si le numéro commence par +, retirer le préfixe
                if (telFixeNumber.startsWith("+")) {
                  telFixeNumber = telFixeNumber.replace(/^\+\d{1,4}\s*/, "");
                }
                // Retirer tous les espaces
                telFixeNumber = telFixeNumber.split(" ").join("");
              }
              
              // S'assurer que c'est une string numérique (retirer tous les caractères non numériques)
              telFixeNumber = telFixeNumber.replace(/\D/g, '');
              
              client.tel_fixe = telFixeNumber;
              client.tel_fixe_phone_number = telFixeNumber;
              client.tel_fixe_phone_iso_code = this.clientData.tel_fixe.phone_iso_code;
            }
          } else {
            const phone = this.cleanPhoneNumber(
              this.clientData.tel.phone_number
            );
            client.phone_number = this.removeSpaces(phone);

              const company_phone = this.cleanPhoneNumber(
                this.clientData?.company_tel?.phone_number
              );
              client.company_phone_number = this.removeSpaces(company_phone);
              
              // Formater tel_fixe_pro comme string
              if (this.clientData.tel_fixe_pro && this.clientData.tel_fixe_pro.phone_number) {
                let telFixeProNumber = this.clientData.tel_fixe_pro.phone_number;
                // Retirer le préfixe du pays et les espaces
                const spaceIndex = telFixeProNumber.indexOf(" ");
                if (spaceIndex !== -1) {
                  telFixeProNumber = telFixeProNumber.slice(spaceIndex + 1).split(" ").join("");
                } else {
                  telFixeProNumber = telFixeProNumber.replace(/^\+\d+/, "").split(" ").join("");
                }
                client.company_tel = telFixeProNumber;
                client.company_phone_number = telFixeProNumber;
                client.company_phone_iso_code = this.clientData.tel_fixe_pro.phone_iso_code;
              }
            }
            client.revenu_avis_imposition =
              this.clientData.revenu_avis_imposition;
            
            // Pour les clients professionnels, s'assurer que siret et email sont bien inclus
            if (this.clientData.type === "type.professionnel") {
              // S'assurer que siret est inclus
              if (this.clientData.siret !== undefined && this.clientData.siret !== null) {
                client.siret = this.clientData.siret;
              }
              
              // Mapper email vers email et company_email pour professionnel
              if (this.clientData.email) {
                client.email = this.clientData.email;
                client.company_email = this.clientData.email;
              } else if (this.clientData.company_email) {
                client.email = this.clientData.company_email;
                client.company_email = this.clientData.company_email;
              } else if (this.clientData.email) {
                client.email = this.clientData.email;
                client.company_email = this.clientData.email;
              }
              
              // Mapper nom et prenom depuis signataire pour professionnel
              if (this.clientData.signataire_nom) {
                client.nom = this.clientData.signataire_nom;
              }
              if (this.clientData.signataire_prenom) {
                client.prenom = this.clientData.signataire_prenom;
              }
              
              // Mapper poste depuis fonction pour professionnel
              if (this.clientData.fonction) {
                client.poste = this.clientData.fonction;
              }
              
              // Inclure tous les autres champs professionnels
              if (this.clientData.raison_sociale !== undefined) {
                client.raison_sociale = this.clientData.raison_sociale;
              }
              if (this.clientData.nom_commercial !== undefined) {
                client.nom_commercial = this.clientData.nom_commercial;
              }
              if (this.clientData.civilite !== undefined) {
                client.civilite = this.clientData.civilite;
              }
              if (this.clientData.signataire_nom !== undefined) {
                client.signataire_nom = this.clientData.signataire_nom;
              }
              if (this.clientData.signataire_prenom !== undefined) {
                client.signataire_prenom = this.clientData.signataire_prenom;
              }
              if (this.clientData.fonction !== undefined) {
                client.fonction = this.clientData.fonction;
              }
              if (this.clientData.email !== undefined) {
                client.email = this.clientData.email;
              }
            }
            
            const editClientResult = await this.edit_client({ data: client });
            
            // Vérifier si l'update du client a échoué
            if (!editClientResult || (typeof editClientResult === 'string' && editClientResult.toLowerCase().includes('error'))) {
            console.error('Erreur lors de la mise à jour du client:', editClientResult);
            this.$refs.snackbar.showSnackbar(`${this.$t("Erreur lors de la mise à jour du client")}`);
            this.isLoading = false;
            return;
          }
        }
        
        // ===============================================
        // MAINTENANT METTRE À JOUR LOGEMENT ET MÉNAGE
        // (CETTE PARTIE S'EXÉCUTE TOUJOURS, PAS CONDITIONNELLE)
        // ===============================================
        const resclient = await this.client(this.clientData?.id);

        // Ménage uniquement pour les clients particuliers
        if (this.clientData.type === 'type.particulier' && this.clientData?.id) {
          // Utiliser l'ID du ménage depuis resclient si disponible, sinon depuis getdevisMonoFiche
          const menageId = resclient?.data?.menage?.id || 
                          this.getdevisMonoFiche.data.devis.client?.menage?.id ||
                          this.clientData.menage?.id;
          
          if (menageId) {
            const menage = {
              ...this.menageData,
              client_id: this.clientData.id,
              id: menageId,
            };
            const editResult = await this.editMenage(menage);
            
            // Vérifier si l'update a échoué
            if (typeof editResult === 'string' && editResult.toLowerCase().includes('error')) {
              console.error('Erreur lors de la mise à jour du ménage:', editResult);
              this.$refs.snackbar.showSnackbar(`${this.$t("Erreur lors de la mise à jour du ménage")}`);
              this.isLoading = false;
              return;
            }
            if (!editResult || !editResult.id) {
              console.error('Erreur lors de la mise à jour du ménage:', editResult);
              this.$refs.snackbar.showSnackbar(`${this.$t("Erreur lors de la mise à jour du ménage")}`);
              this.isLoading = false;
              return;
            }
          } else if (!this.clientData.menage && !resclient?.data?.menage) {
            // Si le ménage n'existe pas encore, le créer
            const menage = {
              ...this.menageData,
              client_id: this.clientData.id,
            };
            await this.storeMenage(menage);
          }
        }

        // Toujours sauvegarder le logement et mettre à jour logement_id
        const log = {
          ...this.logementData,
          client_id: this.clientData?.id,
        };
        
        console.log('DEBUG PAYLOAD LOG: log =', log);
        console.log('DEBUG PAYLOAD LOG: code_postal =', log.code_postal);
        console.log('DEBUG PAYLOAD LOG: ville =', log.ville);
        
        // Déterminer l'ID du logement à utiliser
        const logementIdToUse = this.logementData.id || this.getdevisMonoFiche.data.devis.logement_id;
        console.log('DEBUG LOGEMENT: logementIdToUse =', logementIdToUse);
        console.log('DEBUG LOGEMENT: this.logementData.id =', this.logementData.id);
        console.log('DEBUG LOGEMENT: devis.logement_id =', this.getdevisMonoFiche.data.devis.logement_id);
        console.log('DEBUG LOGEMENT: logementData =', this.logementData);
        
        // Si l'ID du logement est null, créer un nouveau logement
        let logementresult;
        if (!logementIdToUse) {
          console.log('DEBUG LOGEMENT: Appel storeLogement');
          logementresult = await this.storeLogement(log);
          this.getdevisMonoFiche.data.devis.logement_id = logementresult.data.id;
          this.logementData.id = logementresult.data.id;
        } else {
          console.log('DEBUG LOGEMENT: Appel editLogement avec ID:', logementIdToUse);
          log.id = logementIdToUse;
          const editResult = await this.editLogement(log);
          console.log('DEBUG LOGEMENT: editResult =', editResult);
          
          // Vérifier si l'update a échoué
          if (typeof editResult === 'string' && editResult.toLowerCase().includes('error')) {
            console.error('Erreur lors de la mise à jour du logement:', editResult);
            this.$refs.snackbar.showSnackbar(`${this.$t("Erreur lors de la mise à jour du logement")}`);
            this.isLoading = false;
            return;
          }
          if (!editResult || !editResult.id) {
            console.error('Erreur lors de la mise à jour du logement:', editResult);
            this.$refs.snackbar.showSnackbar(`${this.$t("Erreur lors de la mise à jour du logement")}`);
            this.isLoading = false;
            return;
          }
          
          logementresult = { data: { id: editResult.id } };
          // S'assurer que logement_id est à jour dans le devis
          if (this.getdevisMonoFiche.data.devis.logement_id !== editResult.id) {
            this.getdevisMonoFiche.data.devis.logement_id = editResult.id;
          }
          // S'assurer que logementData.id est à jour
          if (this.logementData.id !== editResult.id) {
            this.logementData.id = editResult.id;
          }
        }
        
        // Toujours mettre à jour logement_id et l'objet logement dans le devis
        this.getdevisMonoFiche.data.devis.logement_id = logementresult.data.id;
        this.getdevisMonoFiche.data.devis.logement = {
          id: logementresult.data.id,
          adresse: this.logementData.adresse,
          type: this.logementData.type,
          proprietaire_occupant: this.logementData.proprietaire_occupant,
          residence_principale_proprietaire:
            this.logementData.residence_principale_proprietaire,
          equipement_deposee: this.logementData.equipement_deposee,
          type_energie_equipement_deposee:
            this.logementData.type_energie_equipement_deposee,
          periode_de_construction:
            this.logementData.periode_de_construction,
          surface: this.logementData.surface,
          parcelle_cadastrale: this.logementData.parcelle_cadastrale,
          type_chauffage: this.logementData.type_chauffage,
          altitude: this.logementData.altitude,
          NPDL: this.logementData.NPDL,
          NPRM: this.logementData.NPRM,
          NPCE: this.logementData.NPCE,
          secteur_activite: this.logementData.secteur_activite,
          siret: this.logementData.siret,
          nom_site: this.logementData.nom_site,
          complement: this.logementData.complement,
          code_postal: this.logementData.code_postal,
          complement_adresse: this.logementData.complement_adresse,
          ville: this.logementData.ville,
          quartier_qpv: this.logementData.quartier_qpv,
          nom_de_quartier: this.logementData.nom_de_quartier,
          code_de_quartier: this.logementData.code_de_quartier,
          surface_au_sol: this.logementData.surface_au_sol,
        };
        
        // S'assurer que logement_id est bien défini dans le devis
        this.getdevisMonoFiche.data.devis.logement_id = logementresult.data.id;
        
        // Sauvegarder immédiatement les modifications du logement
        this.setDevisMonoFiche(this.getdevisMonoFiche);

        const clientObject = {
            id: this.clientData.id,
            precarite: this.clientData?.precarite,
            pays: this.clientData?.pays,
            nom: this.clientData?.nom,
            prenom: this.clientData?.prenom,
            rue: this.clientData?.rue,
            zone: this.clientData?.zone,
            type: this.clientData?.type,
            ville: this.clientData?.ville,
            phone: resclient?.data.phone,
            company_phone: resclient?.data.company_phone,
            cp: this.clientData?.cp,
            email: this.clientData?.email,
            company: this.clientData?.company,
            company_email: this.clientData?.company_email,
            SWIFT_BIC: this.clientData?.SWIFT_BIC,
            forme_juridique: this.clientData?.forme_juridique,
            naf: this.clientData?.naf,
            ape: this.clientData?.ape,
            revenu_avis_imposition: this.clientData?.revenu_avis_imposition,
            IBAN: this.clientData?.IBAN,
            titulaire_compte: this.clientData?.titulaire_compte,
            poste: this.clientData?.poste,
            commentaire: this.clientData?.commentaire,
            company_tel: resclient?.data.company_tel,
            logements: this.clientData?.logements,
            // Champs pour les clients particuliers
            civilite_1: this.clientData?.civilite_1,
            civilite_2: this.clientData?.civilite_2,
            nom_2: this.clientData?.nom_2,
            prenom_2: this.clientData?.prenom_2,
            email_2: this.clientData?.email_2,
            complement_adresse: this.clientData?.complement_adresse,
            tel_mobile: this.clientData?.tel_mobile,
            tel_fixe: this.clientData?.tel_fixe,
            // Champs pour les clients professionnels
            raison_sociale: this.clientData?.raison_sociale,
            nom_commercial: this.clientData?.nom_commercial,
            siret: this.clientData?.siret,
            civilite: this.clientData?.civilite,
            signataire_nom: this.clientData?.signataire_nom,
            signataire_prenom: this.clientData?.signataire_prenom,
            fonction: this.clientData?.fonction,
            type_occupation: this.clientData?.type_occupation,
          
            tel_mobile_pro: this.clientData?.tel_mobile_pro,
            tel_fixe_pro: this.clientData?.tel_fixe_pro,
        };
        
        // Ajouter le ménage uniquement pour les clients particuliers
        if (this.clientData.type === 'type.particulier' && resclient?.data?.menage) {
          clientObject.menage = {
            id: resclient.data.menage.id,
            commune: this.menageData.commune,
            personnes: this.menageData.personnes,
            revenu: this.menageData.revenu,
            foyer_fiscal: this.menageData.foyer_fiscal || null,
            annee_revenus: this.menageData.annee_revenus || null,
            annee_imposition: this.menageData.annee_imposition || null,
          };
        }
        
        this.getdevisMonoFiche.data.devis.client = clientObject;

        this.setDevisMonoFiche(this.getdevisMonoFiche);
      }
    },
    cleanPhoneNumber(phoneNumber) {
      if (!phoneNumber) return "";
      return phoneNumber.replace(/^\+\d+\s*/, "");
    },
    removeSpaces(phoneNumber) {
      if (!phoneNumber) return "";
      return phoneNumber.replace(/\s+/g, "");
    },
    async goToNextStep() {
      this.isLoading = true;
      
      // Valider le formulaire client avant de continuer
      if (this.$refs.creeClient && typeof this.$refs.creeClient.validateForm === 'function') {
        const isFormValid = await this.$refs.creeClient.validateForm();
        if (!isFormValid) {
          this.$refs.snackbar.showSnackbar(`${this.$t("Tous_obligatoires")}`);
          this.isLoading = false;
          return;
        }
      }
      
      // Valider que le code postal du logement est obligatoire
      if (!this.logementData?.code_postal || this.logementData.code_postal.trim() === '') {
        this.$refs.snackbar.showSnackbar(`${this.$t("POSTAL_CODE")} ${this.$t("est obligatoire")}`);
        this.isLoading = false;
        return;
      }
      
      try {
        // Attendre que l'édition du logement, client et ménage se termine complètement
        await this.edit();
        
        // Vérifier les erreurs d'email
        if(this.emittedResponse == 422 || this.emittedResponse == 409) {
          this.$refs.snackbar.showSnackbar( `${this.$t("e-mail existe déjà")}`);
          this.err = false;
          this.isLoading = false;
          return;
        }
      } catch (error) {
        console.error("Error in edit():", error);
        this.$refs.snackbar.showSnackbar(`${this.$t("Erreur lors de la sauvegarde des données")}`);
        this.isLoading = false;
        return;
      }
      
      // Sauvegarder les données actuelles du client
      try {
        this.saveCurrentClientData();
      } catch (error) {
        console.error("Error in saveCurrentClientData():", error);
      }
      
      // Désactiver le loading et passer à l'étape suivante (APRÈS la sauvegarde complète)
      this.isLoading = false;
      this.$emit("changeStep", 3, true);
    },
    goToPrevStep() {
      // Sauvegarder les modifications actuelles avant de changer d'étape
      this.saveCurrentClientData();
      
      this.$emit("changeStepPrev", 1);
    },
    formatPhoneNumbers() {
      if (!this.clientData) return;
      
      // Pour les clients particuliers
      if (this.clientData.type === 'type.particulier') {
        // Téléphone mobile depuis phone ou tel_mobile
        if (this.clientData.phone && !this.clientData.tel_mobile) {
          const phoneNumber = this.clientData.phone.phone_number || null;
          const isoCode = this.clientData.phone.iso_code || 
                         this.clientData.phone.country_id?.iso_code || 
                         'FR';
          const formatedPhone = this.clientData.phone.formated_phone || null;
          
          this.$set(this.clientData, 'tel_mobile', {
            phone_number: phoneNumber,
            phone_iso_code: isoCode,
            iso_code: isoCode,
            formated_phone: formatedPhone,
          });
        }
        
        // Téléphone fixe - formater depuis tel_fixe ou tel_fixe_phone_number
        if (!this.clientData.tel_fixe && this.clientData.tel_fixe_phone_number) {
          this.$set(this.clientData, 'tel_fixe', {
            phone_number: this.clientData.tel_fixe_phone_number,
            phone_iso_code: this.clientData.tel_fixe_phone_iso_code || 'FR',
            formated_phone: null,
          });
        } else if (this.clientData.tel_fixe && typeof this.clientData.tel_fixe === 'string') {
          this.$set(this.clientData, 'tel_fixe', {
            phone_number: this.clientData.tel_fixe,
            phone_iso_code: 'FR',
            formated_phone: null,
          });
        }
      }
      
      // Pour les clients professionnels
      if (this.clientData.type === 'type.professionnel') {
        // Téléphone mobile pro depuis phone
        if (this.clientData.phone && !this.clientData.tel_mobile_pro) {
          const phoneNumber = this.clientData.phone.phone_number || null;
          const isoCode = this.clientData.phone.iso_code || 
                         this.clientData.phone.country_id?.iso_code || 
                         'FR';
          const formatedPhone = this.clientData.phone.formated_phone || null;
          
          this.$set(this.clientData, 'tel_mobile_pro', {
            phone_number: phoneNumber,
            phone_iso_code: isoCode,
            formated_phone: formatedPhone,
          });
        }
        
        // Téléphone fixe pro depuis company_phone
        if (this.clientData.company_phone && !this.clientData.tel_fixe_pro) {
          const companyPhoneNumber = this.clientData.company_phone.phone_number || null;
          const companyIsoCode = this.clientData.company_phone.iso_code || 
                                this.clientData.company_phone.country_id?.iso_code || 
                                'FR';
          const companyFormatedPhone = this.clientData.company_phone.formated_phone || null;
          
          if (companyPhoneNumber) {
            this.$set(this.clientData, 'tel_fixe_pro', {
              phone_number: companyPhoneNumber,
              phone_iso_code: companyIsoCode,
              formated_phone: companyFormatedPhone,
            });
          }
        }
      }
    },
    saveCurrentClientData() {
      // Sauvegarder les modifications actuelles dans getdevisMonoFiche
      if (this.getdevisMonoFiche && this.getdevisMonoFiche.data && this.getdevisMonoFiche.data.devis) {
        if (!this.getdevisMonoFiche.data.devis.client) {
          this.getdevisMonoFiche.data.devis.client = {};
        }
        
        // Mettre à jour client_id si l'ID du client a changé
        if (this.clientData && this.clientData.id) {
          this.getdevisMonoFiche.data.devis.client_id = this.clientData.id;
        }
        
        // Mettre à jour les champs du client dans getdevisMonoFiche avec les données actuelles
        // Inclure tous les champs, y compris les nouveaux
        const fieldsToSave = [
          'nom', 'prenom', 'rue', 'zone', 'cp', 'ville', 'id', 'precarite', 'type',
          'email', 'pays', 'phone', 'company_phone', 'company', 'company_email',
          'revenu_avis_imposition', 'SWIFT_BIC', 'forme_juridique', 'ape', 'naf',
          'IBAN', 'titulaire_compte', 'poste', 'commentaire', 'logements',
          // Champs pour les clients particuliers
          'civilite_1', 'civilite_2', 'nom_2', 'prenom_2', 'email_2',
          'complement_adresse', 'tel_mobile', 'tel_fixe',
          // Champs pour les clients professionnels
          'raison_sociale', 'nom_commercial', 'siret', 'civilite',
          'signataire_nom', 'signataire_prenom', 'fonction', 'email',
          'type_occupation', 'tel_mobile_pro', 'tel_fixe_pro'
        ];
        
        fieldsToSave.forEach(key => {
          if (this.clientData[key] !== undefined && this.clientData[key] !== null) {
            this.getdevisMonoFiche.data.devis.client[key] = this.clientData[key];
          }
        });
        
        // Sauvegarder aussi les données de ménage si elles existent
        if (this.menageData) {
          if (!this.getdevisMonoFiche.data.devis.client.menage) {
            this.getdevisMonoFiche.data.devis.client.menage = {};
          }
          Object.keys(this.menageData).forEach(key => {
            if (this.menageData[key] !== undefined && this.menageData[key] !== null) {
              this.getdevisMonoFiche.data.devis.client.menage[key] = this.menageData[key];
            }
          });
        }
        
        // Sauvegarder aussi les données du logement et logement_id
        if (this.logementData) {
          if (!this.getdevisMonoFiche.data.devis.logement) {
            this.getdevisMonoFiche.data.devis.logement = {};
          }
          
          // Mettre à jour tous les champs du logement
          Object.keys(this.logementData).forEach(key => {
            if (this.logementData[key] !== undefined && this.logementData[key] !== null) {
              this.getdevisMonoFiche.data.devis.logement[key] = this.logementData[key];
            }
          });
          
          // S'assurer que logement_id est à jour si logementData.id existe
          if (this.logementData.id) {
            this.getdevisMonoFiche.data.devis.logement_id = this.logementData.id;
          }
        }
        
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      }
    },
    handleLogementUpdate({ field, value }) {
      // Assurer que la propriété existe dans logementData en utilisant Vue.set
      this.$set(this.logementData, field, value);
      
      // TOUJOURS mettre à jour le logement dans le devis et Vuex
      // (Même si c'est un nouveau logement, on doit garder les données à jour)
      this.getdevisMonoFiche.data.devis.logement = { ...this.logementData };
      
      // Toujours synchroniser logement_id avec logementData.id (null si désélection)
      this.getdevisMonoFiche.data.devis.logement_id = this.logementData.id ?? null;
      
      this.setDevisMonoFiche(this.getdevisMonoFiche);
      
      // Ajouter du débogage
      console.log('DEBUG handleLogementUpdate: field =', field, 'value =', value);
      console.log('DEBUG handleLogementUpdate: this.logementData =', this.logementData);
      
      // Mettre à jour aussi le client et le ménage associés
      if (this.clientData && this.clientData.id) {
        this.getdevisMonoFiche.data.devis.client = { ...this.clientData };
      }
      
      if (this.menageData && this.clientData?.menage?.id) {
        this.getdevisMonoFiche.data.devis.menage = { ...this.menageData };
      }
    },
    handleMenageUpdate({ field, value }) {
      this.menageData[field] = value;
      
      // Toujours mettre à jour le ménage dans le devis
      if (this.menageData) {
        this.getdevisMonoFiche.data.devis.menage = { ...this.menageData };
        this.setDevisMonoFiche(this.getdevisMonoFiche);
      }
      
      // Mettre à jour aussi le logement et le client associés
      if (this.logementData && this.logementData.id) {
        this.getdevisMonoFiche.data.devis.logement = { ...this.logementData };
        this.getdevisMonoFiche.data.devis.logement_id = this.logementData.id;
      }
      
      if (this.clientData && this.clientData.id) {
        this.getdevisMonoFiche.data.devis.client = { ...this.clientData };
      }
    },
    handleSameTravaux(value) {
      // Mettre à jour same_travaux_address dans le devis
      if (this.getdevisMonoFiche && this.getdevisMonoFiche.data && this.getdevisMonoFiche.data.devis) {
        this.getdevisMonoFiche.data.devis.same_travaux_address = value;
        this.setDevisMonoFiche(this.getdevisMonoFiche);
        
        console.log('DEBUG SAME TRAVAUX: same_travaux_address updated to', value);
      }
    },
    handleClientUpdate(updatedData) {
      // Met à jour l'objet complet - créer une nouvelle référence pour garantir la réactivité
      this.clientData = { ...updatedData };
      
      // Mettre à jour client_id dans le devis si l'ID du client a changé
      if (updatedData.id && this.getdevisMonoFiche && this.getdevisMonoFiche.data && this.getdevisMonoFiche.data.devis) {
        const oldClientId = this.getdevisMonoFiche.data.devis.client_id;
        const newClientId = updatedData.id;
        
        // Si l'ID du client a changé, mettre à jour client_id dans le devis
        if (oldClientId !== newClientId) {
          this.getdevisMonoFiche.data.devis.client_id = newClientId;
          
          // Réinitialiser logement_id car le nouveau client peut avoir des logements différents
          this.getdevisMonoFiche.data.devis.logement_id = null;
          this.getdevisMonoFiche.data.devis.logement = null;
          
          // Charger les logements du nouveau client
          this.loadClientLogements();
        }
      }
      
      // Sauvegarder immédiatement les modifications dans getdevisMonoFiche pour qu'elles persistent
      this.saveCurrentClientData();
    }
  }
};
</script>
<style scoped>
.borderPointier {
  border: 2px dashed #24316d;
  position: relative;
}

.background-white {
  display: inline-block;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  position: absolute;
  top: -1rem;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
}
.title {
  color: #24316d;
  position: relative;
  z-index: 2;
  margin: 0;
}

.position {
  background-color: white;
  display: inline-block;
  padding: 0.05rem 2rem;
}
</style>
